import {
  type TermsAndConditionsResponseType,
  type AnswerType_InputType
} from '@shared/generated';

export const isTermsAndConditionsResponseType = (
  answer: AnswerType_InputType
): answer is TermsAndConditionsResponseType => {
  if (answer === null || answer === undefined || typeof answer !== 'object') {
    return false;
  }
  if (
    'id' in answer &&
    'details' in answer &&
    'isCurrent' in answer &&
    'program_id' in answer &&
    'program' in answer &&
    'milestone' in answer
  ) {
    return true;
  } else {
    return false;
  }
};
